<img *ngIf="safeImageUrl" [src]="safeImageUrl" [alt]="altText"/>
